import { Component, input } from '@angular/core';

@Component({
  selector: 'app-spinner-loader',
  standalone: true,
  imports: [],
  templateUrl: './spinner-loader.component.html',
  styleUrl: './spinner-loader.component.css'
})
export class SpinnerLoaderComponent {
  width = input(50);
}
